import React from "react";
import DetalhesDocumentoDialog from "./DetalhesIntegracaoDocumentoDialog";

const DetalhesDocumentoDialogConnected = ({
  handleClose,
  dados: { open, ...otherData },
}) => {
  return (
    <DetalhesDocumentoDialog
      open={open}
      handleClose={handleClose}
      detalhes={otherData}
    />
  );
};

export default DetalhesDocumentoDialogConnected;
